import styled from "styled-components";

export const BonusCardTitleStyled = styled.div`
    padding-right: 3px;
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : 'var(--color-surface-secondary)'};
    color: ${({ color }) => color ? color : '#EBC962'};
    font-weight: 600;
    border-radius: 0 4px 4px 0;
    display: flex;
    align-items: center;
    
    > div {
        line-height: 24px;
    }
`;